import { defa }     from 'defa-object';
import ZoneSettings from 'scripts/defa/settings-home/model-zone-settings'
import Model        from 'scripts/poppet/model';

const channel = Bb.Radio.channel( 'objects' );
const apiHost = defa.vars.apiHost;

const api = {
	settingsHome: apiHost + '/settingshomes',
};
/**
 * defa.models.SettingsHome
 * The Model for the SettingsHome
 * @version 1.2.1
 */
const SettingsHome = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.settingsHome,
	
	defaults: {
		gpaiAlias: null,
		location: null,
		zone1: new ZoneSettings().defaults,
		zone2: new ZoneSettings().defaults,
		zone3: new ZoneSettings().defaults,
		zone4: new ZoneSettings().defaults,
		zone5: new ZoneSettings().defaults,
		zone6: new ZoneSettings().defaults,
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Parses data from the backend before updating the model.
	 * @param  {object} response  The response from the backend.
	 * @return {object}           The parsed data from the backend.
	 * @overwrite
	 */
	parse: function ( response ) {
		if ( response ){
			channel.request( 'settingsHomes' ).add( response, { merge: true } );
			
			// if this is a first saved object, save the new id on the unit.
			if ( this.get( 'unit' ) ) {
				channel.request( 'units' ).add( {
					id : this.get( 'unit' ),
					transientSettingsHome: response.id,
				}, {
					merge: true,
				} );
			}
		}
		return response;
	},
	
	saveAlarmMessage: function( alarmMessage ) {
		if(this.get('id')) {
			let self = this;
			this.save({gpaiAlias: alarmMessage}, {
				patch: true,
				success: function() {
					console.log("Save alarmMessage success");
				},
				error: function() {
					console.log("Save alarm failed");
				},
			});
		} else {
			//No settings home exists
			let self = this;
			console.log("First time");
			this.save({gpaiAlias: alarmMessage}, {
				type: 'POST',
				url: api.settingsHome,
				success: function() {
					console.log("Save alarmMessage success");
				},
				error: function() {
					console.log("Save alarm failed");
				},
			});
		}
	},

	saveLocation: function ( location ) {
		if(this.get('id')) {
			let self = this;
			this.save({location: location.id}, {
				patch: true,
				success: function() {
					console.log("Save location success");
				},
				error: function() {
					console.log("Save location failed");
				},
			});
		} else {
			//No settings home exists
			let self = this;
			console.log("First time");
			this.save({location: location.id}, {
				type: 'POST',
				url: api.settingsHome,
				success: function() {
					console.log("Save location success");

				},
				error: function() {
					console.log("Save location failed");
				},
			});
		}
	},
	
	saveZone: function (zone, zoneNumber) {
		switch ( zoneNumber ) {
			case 1:
				this.saveZone1( zone );
				break;
			
			case 2:
				this.saveZone2( zone );
				break;
			
			case 3:
				this.saveZone3( zone );
				break;
			
			case 4:
				this.saveZone4( zone );
				break;
			
			case 5:
				this.saveZone5( zone );
				break;
			
			case 6:
				this.saveZone6( zone );
				break;
		}
	},
	
	saveZone1: function ( zone ) {
		if(this.get('id')) {
			let self = this;
			this.save({zone1 : zone}, {
				patch: true,
				success: function() {
					console.log('Save Zone1 Success');
				},
				error: function() {
					console.log("Save zone1 failed");
				},
			});
		} else {
			//No settings home exists
			let self = this;
			console.log("First time");
			this.save({zone1: zone}, {
				type: 'POST',
				url: api.settingsHome,
				success: function() {
					console.log('Save Zone1 Success');
				},
				error: function() {
					console.log("Save zone1 failed");
				},
			});
		}
	},
	
	saveZone2: function ( zone ) {
		if(this.get('id')) {
			console.log('SAVING ZONESETTINGS');
			let self = this;
			this.save({zone2 : zone}, {
				patch: true,
				success: function() {
					console.log('Save Zone2 Success');
				},
				error: function() {
					console.log("Save zone2 failed");
				},
			});
		} else {
			//No settings home exists
			let self = this;
			console.log("First time");
			this.save({zone2: zone}, {
				type: 'POST',
				url: api.settingsHome,
				success: function() {
					console.log('Save Zone2 Success');
				},
				error: function() {
					console.log("Save zone2 failed");
				},
			});
		}
	},
	
	saveZone3: function ( zone ) {
		if(this.get('id')) {
			console.log('SAVING ZONESETTINGS');
			let self = this;
			this.save({zone3 : zone}, {
				patch: true,
				success: function() {
					console.log('Save Zone3 Success');
				},
				error: function() {
					console.log("Save zone3 failed");
				},
			});
		} else {
			//No settings home exists
			let self = this;
			console.log("First time");
			this.save({zone3: zone}, {
				type: 'POST',
				url: api.settingsHome,
				success: function() {
					console.log('Save Zone3 Success');
				},
				error: function() {
					console.log("Save zone3 failed");
				},
			});
		}
	},
	
	saveZone4: function ( zone ) {
		if(this.get('id')) {
			console.log('SAVING ZONESETTINGS');
			let self = this;
			this.save({zone4 : zone}, {
				patch: true,
				success: function() {
					console.log('Save Zone4 Success');
				},
				error: function() {
					console.log("Save zone4 failed");
				},
			});
		} else {
			//No settings home exists
			let self = this;
			console.log("First time");
			this.save({zone4: zone}, {
				type: 'POST',
				url: api.settingsHome,
				success: function() {
					console.log('Save Zone4 Success');
				},
				error: function() {
					console.log("Save zone4 failed");
				},
			});
		}
	},
	
	saveZone5: function ( zone ) {
		if(this.get('id')) {
			console.log('SAVING ZONESETTINGS');
			let self = this;
			this.save({zone5 : zone}, {
				patch: true,
				success: function() {
					console.log('Save Zone5 Success');
				},
				error: function() {
					console.log("Save zone5 failed");
				},
			});
		} else {
			//No settings home exists
			let self = this;
			console.log("First time");
			this.save({zone5: zone}, {
				type: 'POST',
				url: api.settingsHome,
				success: function() {
					console.log('Save Zone5 Success');
				},
				error: function() {
					console.log("Save zone5 failed");
				},
			});
		}
	},
	
	saveZone6: function ( zone ) {
		if(this.get('id')) {
			console.log('SAVING ZONESETTINGS');
			let self = this;
			this.save({zone6 : zone}, {
				patch: true,
				success: function() {
					console.log('Save Zone6 Success');
				},
				error: function() {
					console.log("Save zone6 failed");
				},
			});
		} else {
			//No settings home exists
			let self = this;
			console.log("First time");
			this.save({zone6: zone}, {
				type: 'POST',
				url: api.settingsHome,
				success: function() {
					console.log('Save Zone6 Success');
				},
				error: function() {
					console.log("Save zone6 failed");
				},
			});
		}
	},
} );

export default SettingsHome;
